export const offerLanguages = {
  en: {
    // Privacy notice
    privacyNotice: "Do not share with anyone besides your inner circle.",
    
    // Customer info labels
    customerLogoPlaceholder: "Customer logo",
    forLabel: "For:",
    createdOnLabel: "Created on:",
    validUntilLabel: "Valid until:",
    deliveryTimeLabel: "Delivery time:",
    referenceLabel: "Reference:",
    
    // Services section
    includedServicesHeading: "Included Services",
    noServicesSelected: "No services selected",
    serviceColumnHeader: "Service",
    priceColumnHeader: "Price",
    discountColumnHeader: "%",
    finalColumnHeader: "Final",
    monthlyBadge: "Monthly",
    
    // Summary section
    totalValueOfServices: "Total value of services:",
    serviceDiscounts: "Service discounts:",
    globalDiscount: "Global discount:",
    subtotal: "Subtotal:",
    taxes: "Taxes:",
    reverseCharge: "Export of services – Not subject to VAT",
    reverseChargeInfo: "This service is supplied to a business customer outside the EU. According to § 3a (2) UStG / Article 44 EU VAT Directive, the place of supply is the recipient's country. No VAT is charged. The customer is responsible for any tax obligations in their jurisdiction.",
    offerPrice: "Total price:",
    oneTimePayment: "One-time payment:",
    monthlyPayment: "Monthly payment:",
    
    // Payment button
    defaultPaymentButtonText: "Pay with Stripe",
    
    // Footer section
    offerCreatedBy: "Offer created for you by",
    questionsContact: "Contact us:",
    defaultContact: "contact@yourcompany.io",
    defaultCompanySlogan: "Your expert platform for digital marketing",
    bankingDetails: "Banking Details",
    contactHeader: "Contact",
    defaultWebsite: "www.bonusclub.io",
    defaultEmail: "info@bonusclub.io",
    
    // Loading and error states
    loadingText: "Loading offer preview...",
    noOfferAvailable: "No offer preview available"
  },
  
  de: {
    // Privacy notice
    privacyNotice: "Vertraulich - nur für den internen Gebrauch bestimmt.",
    
    // Customer info labels
    customerLogoPlaceholder: "Firmenlogo",
    forLabel: "Kunde:",
    createdOnLabel: "Erstellt:",
    validUntilLabel: "Gültig bis:",
    deliveryTimeLabel: "Lieferzeit:",
    referenceLabel: "Referenz:",
    
    // Services section
    includedServicesHeading: "Leistungsumfang",
    noServicesSelected: "Keine Leistungen ausgewählt",
    serviceColumnHeader: "Leistung",
    priceColumnHeader: "Preis",
    discountColumnHeader: "%",
    finalColumnHeader: "Endpreis",
    monthlyBadge: "Monatlich",
    
    // Summary section
    totalValueOfServices: "Gesamtwert:",
    serviceDiscounts: "Rabatte:",
    globalDiscount: "Gesamtrabatt:",
    subtotal: "Zwischensumme:",
    taxes: "MwSt.:",
    reverseCharge: "Dienstleistungsexport – Steuerfrei",
    reverseChargeInfo: "Diese Leistung wird an einen Geschäftskunden außerhalb der EU erbracht. Nach § 3a (2) UStG / Artikel 44 EU-MwSt-Richtlinie ist der Leistungsort das Land des Empfängers. Es wird keine MwSt. berechnet. Der Kunde ist für die steuerlichen Verpflichtungen in seinem Land zuständig.",
    offerPrice: "Gesamtbetrag:",
    oneTimePayment: "Einmalzahlung:",
    monthlyPayment: "Monatsrate:",
    
    // Payment button
    defaultPaymentButtonText: "Jetzt bezahlen",
    
    // Footer section
    offerCreatedBy: "Ihr Ansprechpartner:",
    questionsContact: "Kontaktieren Sie uns:",
    defaultContact: "info@bonusclub.io",
    defaultCompanySlogan: "Ihr Partner für digitales Marketing",
    bankingDetails: "Bankdaten",
    contactHeader: "Kontakt",
    defaultWebsite: "www.bonusclub.io",
    defaultEmail: "info@bonusclub.io",
    
    // Loading and error states
    loadingText: "Angebot wird geladen...",
    noOfferAvailable: "Angebot nicht verfügbar"
  }
};

// Helper function to get text by language
export const getOfferText = (language, key) => {
  return offerLanguages[language]?.[key] || offerLanguages.en[key] || key;
};

// Date formatting by language
export const formatDateByLanguage = (timestamp, language) => {
  const date = new Date(timestamp);
  
  if (language === 'de') {
    return date.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit", 
      year: "numeric"
    });
  } else {
    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
  }
};

// Price formatting by language
export const formatPriceByLanguage = (price, language) => {
  if (language === 'de') {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR"
    }).format(price);
  } else {
    return new Intl.NumberFormat("en-US", {
      style: "currency", 
      currency: "EUR"
    }).format(price);
  }
}; 